import { ExportTypes } from 'constants/exportTypes';
import { ExportType } from 'constants/exportTypes';
import { Resources } from 'constants/resources';

import { useState } from 'react';

import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { ListContextProvider, useListController } from 'react-admin';
import { useSearchParams } from 'react-router-dom';
import { ExportTypesButton } from 'shared/mui/Buttons/ExportTypesButton/ExportTypesButton';
import { PageHeader } from 'shared/mui/PageHeader';
import { OrderAdjustments } from 'types/embedded/orderAdjustments';

import { OrderAdjustmentsReportListContent } from './OrderAdjustmentsReportListContent/OrderAdjustmentsReportListContent';

export const OrderAdjustmentsReportList: React.FC = () => {
  const translate = useTypedTranslate();

  const [searchParams] = useSearchParams();
  const [exportType, setExportType] = useState<ExportType>(ExportTypes.Excel);
  const [isOpenNotifyDialog, setIsOpenNotifyDialog] = useState(false);

  const orderAdjustmentsListContext = useListController<OrderAdjustments>({
    queryOptions: {
      enabled: !!searchParams.size,
    },
    resource: Resources.OrderAdjustments,
    sort: { field: 'id', order: 'DESC' },
  });

  return (
    <>
      <ListContextProvider value={orderAdjustmentsListContext}>
        <PageHeader
          actions={[
            <ExportTypesButton
              disabled={!Object.keys(orderAdjustmentsListContext.filterValues).length}
              exportType={exportType}
              key="export-button"
              onChangeType={setExportType}
              onClick={() => setIsOpenNotifyDialog(true)}
            />,
          ]}
          headerTitle={{
            titleText: translate('app.orderAdjustmentsReport.title'),
          }}
          mt={3}
        />
        <OrderAdjustmentsReportListContent
          exportType={exportType}
          isOpenNotifyDialog={isOpenNotifyDialog}
          onCloseNotifyDialog={() => setIsOpenNotifyDialog(false)}
        />
      </ListContextProvider>
    </>
  );
};
